
































































import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'
import VenueMapSelector from '@ui/VenueMapSelector'
import FormField from '@ui/FormBuilder/FormField'
import FormFieldRadioButton from '@ui/FormBuilder/FormFields/FormFieldRadioButton'

settings =
  name: 'FormFieldVenueSelect'

  vue:
    props: ['value', 'errors', 'placeholder', 'nationalVenues', 'supplierId', 'audienceCreativeId']

    components: {
      LoadingIndicator,
      VenueMapSelector,
      FormField,
      FormFieldRadioButton,
    }

    data: ->
      venue: null
      location: null
      search: ''

    computed:
      optionsForVenueClass: ->
        [
          { value: 'venue', label: 'Venue' }
          { value: 'regional', label: 'Regional' }
          { value: 'national', label: 'National' }
          # { value: 'virtual', label: 'Virtual' }
        ]

      optionsForRegionName: ->
        instructions: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
        inputProps:
          placeholder: 'Lorem ipsum dolor'

      regionalTableData: ->
        for location in @venue.regional_locations
          location: @compact([location.city, null, false, undefined, 0, location.state, location.country]).join(', ')
          street: location.street
          zip: location.zip

      nationalTableData: ->
        locations = []
        venues = @nationalVenues || []
        for venue in venues
          switch venue.venue_class
            when 'venue'
              locations.push venue
            when 'regional'
              locations.push ...venue.regional_locations.map((l) =>
                { venue_class, venue_name } = venue
                { venue_class, venue_name, ...l }
              )
        for location in locations
          venueClass = 'In Person' if location.venue_class is 'venue'
          venueClass ||= @$options.filters.formatTitle location.venue_class
          venue: venueClass
          name: location.venue_name
          location: @$options.filters.formatLocation({ ...location, venue_class: null }) # force to display city and state even for regional

    methods:
      hiInputChange: (venue) ->
        @inputChanged venue

      hiVenueClass: (venueClass) ->
        switch venueClass
          when 'venue'
            @resetRegionalFields()
          when 'regional'
            @resetVenueFields()
          when 'national'
            @resetVenueFields()
            @resetRegionalFields()
        @inputChanged @venue

      hiLocationMap: (location) ->
        @venue[key] = location[key] for key of location
        @inputChanged @venue

      hiAddRegionalLocation: (place) ->
        @$refs.autocomplete.$el.value = ''
        location = @placeToRegionalLocation place
        return unless location
        return if @venue.regional_locations.some((v) => @objectsAreEqual(v, location))
        @venue.regional_locations.push location
        @inputChanged @venue

      hiRemoveRegionalLocation: (index) ->
        @venue.regional_locations.splice index, 1
        @inputChanged @venue

      formatRegionalLocation: (regionalLocation) ->
        { city, state } = regionalLocation
        "#{city}, #{state}"

      placeToRegionalLocation: (place) ->
        { name, address_components, geometry } = place
        return unless address_components
        streetName = @extractAddressComponent address_components, 'route'
        streetNumber = @extractAddressComponent address_components, 'street_number'
        street = "#{streetNumber} #{streetName}".trim()
        city = @extractAddressComponent address_components, 'locality'
        city ||= @extractAddressComponent address_components, 'administrative_area_level_2'
        state = @extractAddressComponent address_components, 'administrative_area_level_1', 'short_name'
        zip = @extractAddressComponent address_components, 'postal_code'
        country = @extractAddressComponent address_components, 'country', 'short_name'
        { street, city, state, zip, country }

      extractAddressComponent: (addressComponents, componentType, fromProp = 'long_name') ->
        return component[fromProp].trim() for component in addressComponents when componentType in component.types
        ''

      resetVenueFields: ->
        fields = ['timezone', 'street', 'city', 'state', 'zip', 'country']
        for key in fields
          @location[key] = null
          @venue[key] = null
        @location.geo_coordinates = []
        @venue.geo_coordinates = []
        @location.geo_polygons = []
        @venue.geo_polygons = []
        @location.geo_fenced = false
        @venue.geo_fenced = false

      resetRegionalFields: ->
        @venue.regional_locations = []

      inputChanged: (venue) ->
        @$emit 'input', venue
        @$emit 'change', venue

    watch:
      value:
        deep: true
        immediate: true
        handler: (value) ->
          @venue = value || {}
          @location =
            timezone: value.timezone
            street: value.street
            city: value.city
            state: value.state
            zip: value.zip
            country: value.country
            geo_coordinates: value.geo_coordinates
            geo_polygons: value.geo_polygons
            geo_fenced: value.geo_fenced
            geo_fence_trusted: value.geo_fence_trusted

export default VueOptions.vue settings
